
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 424.728c-24 0-43.636 19.634-43.636 43.636C212.364 492.363 232 512 256 512s43.637-19.637 43.637-43.637c0-24.001-19.637-43.635-43.637-43.635zM125.09 32c-24 0-43.636 19.637-43.636 43.636 0 24 19.636 43.636 43.636 43.636 24.001 0 43.637-19.636 43.637-43.636C168.728 51.637 149.09 32 125.09 32zm0 130.909c-24 0-43.636 19.637-43.636 43.636 0 24 19.636 43.636 43.636 43.636 24.001 0 43.637-19.636 43.637-43.636.001-23.999-19.637-43.636-43.637-43.636zm0 130.908c-24 0-43.636 19.636-43.636 43.638 0 23.999 19.636 43.636 43.636 43.636 24.001 0 43.637-19.637 43.637-43.636.001-24.001-19.637-43.638-43.637-43.638zm261.819-174.545c24.002 0 43.636-19.636 43.636-43.636S410.91 32 386.909 32c-23.999 0-43.637 19.637-43.637 43.636 0 24.001 19.637 43.636 43.637 43.636zM256 293.817c-24 0-43.636 19.636-43.636 43.638 0 23.999 19.636 43.636 43.636 43.636s43.637-19.637 43.637-43.636c0-24.001-19.637-43.638-43.637-43.638zm130.909 0c-24 0-43.637 19.636-43.637 43.638 0 23.999 19.637 43.636 43.637 43.636 24.002 0 43.636-19.637 43.636-43.636 0-24.001-19.636-43.638-43.636-43.638zm0-130.908c-24 0-43.637 19.637-43.637 43.636 0 24 19.637 43.636 43.637 43.636 24.002 0 43.636-19.636 43.636-43.636 0-23.999-19.636-43.636-43.636-43.636zm-130.909 0c-24 0-43.636 19.637-43.636 43.636 0 24 19.636 43.636 43.636 43.636s43.637-19.636 43.637-43.636c0-23.999-19.637-43.636-43.637-43.636zM256 32c-24 0-43.636 19.637-43.636 43.636 0 24 19.636 43.636 43.636 43.636s43.637-19.636 43.637-43.636C299.637 51.637 280 32 256 32z"}})])
          )
        }
      }
    